export function Input({
  header,
  value,
  onChange,
  onKeyDown,
  type = "text",
  className = "",
  disabled,
}) {
  const classes = [
    "ui-input",
    disabled ? "ui-input--disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      {header && <span className="ui-input__label">{header}</span>}
      <div className="ui-input__field">
        <input
          type={type}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
